module.exports = __webpack_public_path__ + "img/slid23.0c95af1b.png";